import React, { useEffect, useRef, useState } from "react";

type SplashQuote = {
  quote: string;
  author: string;
};

const QUOTES: SplashQuote[] = [
  { quote: "Invest first, spend later.", author: "The Payday Discipline Desk" },
  { quote: "If you have saved Rs 100 on a brand-new shirt, you have just earned Rs 100.", author: "The Discount Detective" },
  { quote: "The trouble with the rat race is that even if you win, you're still a rat.", author: "Lily Tomlin" },
  { quote: "There are only two kinds of money problems: not enough money and too much money. Which problem do you want?", author: "Robert Kiyosaki" },
  { quote: "Wealth is the slave of a wise man and the master of a fool.", author: "Seneca" },
  { quote: "I can understand wanting to have a million dollars; it's freedom. But once you get beyond that, it's the same hamburger.", author: "Bill Gates" },
  { quote: "For the love of money is a root of all kinds of evil.", author: "1 Timothy 6:10" },
  { quote: "Inflation is when you pay fifteen dollars for the ten-dollar haircut you used to get for five dollars when you had hair.", author: "Sam Ewing" },
  { quote: "Academic qualifications are important, and so is financial education. They're both important, and schools are forgetting one of them.", author: "Robert Kiyosaki" },
  { quote: "Riches begin with a state of mind and with definiteness of purpose.", author: "Napoleon Hill" },
  { quote: "A credit card is a wonderful tool that allows you to buy things you do not want with money you do not have.", author: "The Credit Card's Lawyer" },
  { quote: "Respect yourself and your money.", author: "The Self-Respect Auditor" },
  { quote: "Invest for cash flow instead of capital gains.", author: "Robert Kiyosaki" },
  { quote: "Start investing. Procrastination has never won a race, earned a promotion, or changed the outcome of any situation.", author: "The Procrastination Pension Fund" },
  { quote: "The person who doesn't invest is no better off than the person who cannot earn.", author: "The Idle Cash Union" },
  { quote: "A windfall without a plan has an impressive talent for disappearing.", author: "The Lottery Exit Interview" },
  { quote: "One dollar compounded at 5% for 500 years grows to roughly $39 billion. Time does most of the work.", author: "The Compound Interest Timekeeper" },
  { quote: "Whether you think you can, or you think you can't, you're right.", author: "Henry Ford" },
  { quote: "Opportunity is a haughty goddess who wastes no time with those who are unprepared.", author: "George S. Clason" },
  { quote: "When money realizes that it is in good hands, it wants to stay and multiply in those hands.", author: "Idowu Koyenikan" },
  { quote: "On salary day, invest first and say it out loud: 'I am a free man.'", author: "The Salary Liberation Desk" },
  { quote: "Some men read Playboy. I read annual reports.", author: "Warren Buffett" },
  { quote: "You have to read a zillion corporate annual reports and their financial statements.", author: "Warren Buffett" },
  { quote: "Hot stocks make their bosses rich.", author: "The Executive Bonus Committee" },
  { quote: "The scariest part of owning a quality compounder is its expensive valuation, which asks for too much perfection in future earnings.", author: "The Valuation Reality Check" },
  { quote: "Prices that go up must eventually come down.", author: "Financial Law of Gravity" },
  { quote: "I can calculate the motion of heavenly bodies, but not the madness of people.", author: "Isaac Newton" },
];

const STORAGE_KEY = "honey_splash_quote_rotation_v4";

function shuffledIndexes(previousLast: number | null) {
  const indexes = QUOTES.map((_, idx) => idx);
  for (let i = indexes.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
  }
  if (previousLast !== null && indexes.length > 1 && indexes[0] === previousLast) {
    [indexes[0], indexes[1]] = [indexes[1], indexes[0]];
  }
  return indexes;
}

function selectQuote(): SplashQuote | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const state = raw ? JSON.parse(raw) : {};
    let queue: number[] = Array.isArray(state.queue) ? state.queue : [];
    const last = typeof state.last === "number" ? state.last : null;
    if (!queue.length) queue = shuffledIndexes(last);
    const next = queue.shift();
    if (typeof next !== "number" || !QUOTES[next]) return null;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ queue, last: next }));
    return QUOTES[next];
  } catch {
    return QUOTES[Math.floor(Math.random() * QUOTES.length)] || null;
  }
}

export const SplashScreen: React.FC<{ leaving?: boolean }> = ({ leaving = false }) => {
  const [quote, setQuote] = useState<SplashQuote | null>(null);
  const quoteSelected = useRef(false);

  useEffect(() => {
    if (quoteSelected.current) return;
    quoteSelected.current = true;
    try {
      setQuote(selectQuote());
    } catch {
      setQuote(null);
    }
  }, []);

  return (
    <div
      className={`splash-screen ${leaving ? "splash-screen--leaving" : ""}`}
      role="status"
      aria-live="polite"
      aria-label="Loading Tenet"
    >
      <div className="splash-content">
        <div className="splash-brand-lockup">
          <div className="splash-brand">Financify</div>
        </div>

        <div className="splash-loading-wrap">
          <div className="splash-loading">Loading Tenet...</div>
        </div>

        {quote ? (
          <div className="splash-quote-wrap">
            <blockquote className="splash-quote">
              <span className="splash-quote-mark" aria-hidden="true">&ldquo;</span>
              {quote.quote}
              <span className="splash-quote-mark" aria-hidden="true">&rdquo;</span>
            </blockquote>
            <div className="splash-author">
              <span aria-hidden="true" />
              {quote.author}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
